import React from 'react';

import BaseAppointment, { BaseAppointmentProps } from '~components/appointments/BaseAppointment';

type AppointmentInfoProps = Omit<BaseAppointmentProps, 'layout' | 'className'>;

const AppointmentInfo: React.FC<AppointmentInfoProps> = (props) => {
  return <BaseAppointment {...props} layout="client-first" />;
};

export default AppointmentInfo;
